import { ClaimProgressEnum, StageState } from '../../../types/type';

export function mapProgressTrackerStep(claimProgress: string): StageState[] {
  // The default values here matter, all visible by default, completed false and active false
  const trackerSteps: StageState[] = [
    {
      name: 'Submit',
      completed: true,
      viewActive: true,
      skipped: false,
      showProgress: true,
      orderOfDisplay: 1,
      id: '1',
    },
    {
      name: '',
      completed: false,
      viewActive: false,
      skipped: false,
      showProgress: true,
      orderOfDisplay: 2,
      id: '2',
    },
    {
      name: '',
      completed: false,
      viewActive: false,
      skipped: false,
      showProgress: true,
      orderOfDisplay: 3,
      id: '3',
    },
    {
      name: '',
      completed: false,
      viewActive: false,
      skipped: false,
      showProgress: true,
      orderOfDisplay: 4,
      id: '4',
    },
  ];

  switch (claimProgress.toUpperCase()) {
    // Submission
    case ClaimProgressEnum.SUBMISSION:
    case ClaimProgressEnum.EVALUATION:
      trackerSteps[0].completed = true;
      trackerSteps[1].viewActive = true;
      break;
    case ClaimProgressEnum.RESOLUTION:
      trackerSteps[0].completed = true;
      trackerSteps[1].completed = true;
      trackerSteps[2].viewActive = true;
      break;
    case ClaimProgressEnum.CLOSED:
      trackerSteps[0].completed = true;
      trackerSteps[1].completed = true;
      trackerSteps[2].completed = true;
      trackerSteps[3].completed = true;
      trackerSteps[3].viewActive = true;
      break;
    default:
      trackerSteps[0].completed = false;
      trackerSteps[1].completed = false;
      trackerSteps[2].completed = false;
      trackerSteps[3].completed = false;
      trackerSteps[0].viewActive = true;
      break;
  }

  return trackerSteps;
}
